import { useState as A, useMemo as E, useEffect as V } from "react";
const l = (r, u = !1, n, t = 0) => {
  const [o, c] = A(n ?? 0), f = E(() => !u && !n && w(o, r, t), [
    r,
    t,
    u,
    n,
    o
  ]);
  return V(() => {
    if (!f && o < r) {
      c(r);
      return;
    }
    const q = performance.now(), P = () => {
      const x = Math.max(performance.now() - q, 0), a = o + x;
      c(a), w(a, r, t) && requestAnimationFrame(P);
    };
    requestAnimationFrame(P);
  }, [
    r,
    f,
    t,
    o
  ]), n !== void 0 ? u ? r : n : o;
}, w = (r, u, n) => r < u || r < n;
export {
  l as useEstimatedProgressValue
};
